import { Link, usePage } from '@inertiajs/react';
import { cn } from '@/lib/utils';
import { type NavItem, type SharedData } from '@/types';
import AppLogo from '@/components/app-logo';
import { BookOpen, Dock } from 'lucide-react';

const footerNavItems: NavItem[] = [
    {
        title: 'Privacy Policy',
        href: route('privacy'),
        icon: BookOpen,
    },
    {
        title: 'Terms Of Use',
        href: route('terms'),
        icon: BookOpen,
    },
    {
        title: 'API Documentation',
        href: route('apiDoc'),
        icon: Dock,
    },
    {
        title: 'Tax Rate By Address',
        href: route('home') + '#tax-rate-by-address',
        icon: Dock,
    },
];

export function AppFooter() {
    const { name} = usePage<SharedData>().props;

    return (
        <footer className="border-t border-sidebar-border/80  py-6 ">
            <div className="mx-auto flex flex-col items-center px-4 md:max-w-7xl md:flex-row md:justify-between">
                <Link aria-label={name} alt="logo" href="/" className="flex items-center space-x-2 mb-4 md:mb-0">
                    {/*<AppLogoIcon className="h-6 w-6 fill-current text-black dark:text-white" />*/}
                    <AppLogo />
                </Link>
                <nav className="flex flex-wrap justify-center gap-4 md:gap-6">
                    {footerNavItems.map((item) => (
                        <Link
                            key={item.title}
                            href={item.href}
                            className={cn(
                                'text-sm hover:text-neutral-900 dark:hover:text-neutral-100 whitespace-nowrap',
                            )}
                        >
                            {item.title}
                        </Link>
                    ))}
                </nav>
            </div>
        </footer>
    );
}
